import React from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { languageShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { Column } from 'components/shared/Layout';
import TextInput from 'components/ui/TextInput';
import Select from 'components/ui/Select';
import { emailReg, isValidName } from 'utils/validators';
import { VoucherLanguages } from 'constants/vouchers';
import { StyledRow, StyledColumn, ErrorMessage, StyledLabel, StyledTitle } from 'pages/CreateVoucher/CreateVoucher.styles';

const RecipientDetails = ({ errors, defaultValues }) => {
  const { register } = useFormContext();

  return (
    <>
      <StyledTitle>
        <FormattedMessage id="createVoucher.recipientDetails" />
      </StyledTitle>
      <StyledRow columns={12}>
        <Column alignItems="flex-start" flexDirection="column" span={3}>
          <StyledLabel htmlFor="firstName">
            <FormattedMessage id="extrasOnlyBookings.fields.firstName" />
          </StyledLabel>
          <TextInput
            data-cy="first-name"
            id="firstName"
            width="100%"
            {...register('firstName', { required: true, validate: isValidName })}
            defaultValue={defaultValues.firstName}
          />
          {errors.firstName && (
            <ErrorMessage>
              <FormattedMessage id="extrasOnlyBookings.errors.firstName" />
            </ErrorMessage>
          )}
        </Column>

        <Column alignItems="flex-start" flexDirection="column" span={3} start={5}>
          <StyledLabel htmlFor="lastName">
            <FormattedMessage id="extrasOnlyBookings.fields.lastName" />
          </StyledLabel>
          <TextInput
            data-cy="last-name"
            id="lastName"
            width="100%"
            {...register('lastName', { required: true, validate: isValidName })}
            defaultValue={defaultValues.lastName}
          />
          {errors.lastName && (
            <ErrorMessage>
              <FormattedMessage id="extrasOnlyBookings.errors.lastName" />
            </ErrorMessage>
          )}
        </Column>

        <Column alignItems="flex-start" flexDirection="column" span={3} start={9}>
          <StyledLabel htmlFor="email">
            <FormattedMessage id="extrasOnlyBookings.fields.email" />
          </StyledLabel>
          <TextInput
            data-cy="email"
            id="email"
            width="100%"
            {...register('email', { required: true, pattern: emailReg })}
            defaultValue={defaultValues.email}
          />
          {errors.email && (
            <ErrorMessage>
              <FormattedMessage id="createVoucher.errors.email" />
            </ErrorMessage>
          )}
        </Column>

        <StyledColumn alignItems="flex-start" flexDirection="column" span={3}>
          <StyledLabel htmlFor="language">
            <FormattedMessage id="createVoucher.fields.language" />
          </StyledLabel>
          <Select {...register('language', { required: true })} id="language" data-cy="language" defaultValue={defaultValues.language}>
            {Object.entries(VoucherLanguages).map(([key, value]) => (
              <FormattedMessage id={value} key={key}>
                {(message) => <option value={key}>{message}</option>}
              </FormattedMessage>
            ))}
          </Select>
        </StyledColumn>
      </StyledRow>
    </>
  );
};

RecipientDetails.propTypes = {
  errors: PropTypes.shape({
    firstName: PropTypes.bool,
    lastName: PropTypes.bool,
    email: PropTypes.bool
  }),
  defaultValues: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    language: languageShape
  })
};

export default RecipientDetails;
